export const config = {
  DEBUG: "api:*",
  API_ADDRESS: process.env.REACT_APP_API_ADDRESS,
};
